import { useUserSettingsContext } from './UserSettingsContext';

const useIsStaff = () => {
  const userContext = useUserSettingsContext();
  if (!userContext) {
    return false;
  }

  return userContext.isStaff;
};

export default useIsStaff;
